export default class ClientReportViewModel {
    public id: number = 0;
    public client: string = '';
    public todayGuid: string = '';
    public historicGuid: string = '';
    public removed: boolean = false;
    public internalOtherLinksGuid: string = '';
    public externalOtherLinksGuid: string = '';
    public clientTodayGuid: string = '';
    public clientHistoricGuid: string = '';
}